import amaLog from '../helpers/log';
import waitFor from '../helpers/waitfor';

let jwAdTracked = false;

export const videostats = (reset: boolean = false): any => {

  amaLog('videoadstats init');

  const onAdRequest = (type: string) => {
    amaLog('videoadstats onAdRequest triggered on', type);

    if (jwAdTracked && reset === false) return;
    jwAdTracked = true;

    if (window.ama) {
      window.ama.adStats.add([
        {
          placement: 'preroll',
          gptEvent: 'slotRequested',
        },
      ]);
      window.ama.adStats.push();
    }
  };

///////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////
///////////

  waitFor(() => typeof window.jwplayer !== 'undefined' && window.jwplayer().on).then(() => {
    amaLog('videoadstats attachListener started');

    window.jwplayer().on('adRequest', () => onAdRequest('"window.jwplayer()" available'));  
  }).catch((error) => {
    amaLog(`videoadstats failed to setup - ${error}`);
  });
};

